import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import CheckCircle from '../../components/CheckCircle';
import Note from '../../components/Note';
import { ANNUAL, DAILY_MODE, MONTHLY, PERFORMANCE_MODE } from '../../constans';
import { useSessionCheck } from '../../hooks/useSessionCheck';
import { t } from 'i18next';
import { useAppContext } from '../../store/AppContext';
import { timestampToDate } from '../../services/firebase';
import usePricing from '../../hooks/usePricing';
import { isActive, isSubscribed, isTrialing } from '../../utils/user';
import { isTesting } from '../../utils/Generic';
import SubscriptionStatus from '../../components/SubscriptionStatus';


export default function PlanChange() {
  //useSessionCheck()
  const pricing = usePricing()
  const { state } = useAppContext()
  const user = state.user
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();
  const disabled = plan == null || (user.subscription.plan.interval == MONTHLY && plan == MONTHLY) || (user.subscription.plan.interval == ANNUAL && plan == ANNUAL)

  const handleNext = () => {
    sessionStorage.setItem('plan', plan);
    navigate('/plan_change_confirmation');
  };

  function trans(key, options) {
    return t("plan_selection_" + key, options)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer}>

        <h1 className={"title title_m_24_medium"} >{trans(68)}</h1>
        <SubscriptionStatus containerStyle={{marginTop: 24}}/>

        <label style={style.subtitle} className='mt-48'>{trans(70)}</label>
        <div style={plan == MONTHLY ? { ...style.card, ...style.cardOn } : style.card}>
          <div style={style.cardContent}>
            <div style={style.cardTitle}>{trans(71)} <span style={style.tag}>{user.subscription.cancelAtPeriodEnd ? t('plan_selection_77') : "ON"}</span></div>
            <div style={style.price} className='mt-8'>${pricing.monthly}<span style={typography.body['15_regular']}> / {t('month').toLowerCase()}</span> </div>
          </div>
          <CheckCircle
            checked={plan == MONTHLY}
            onPress={() => setPlan(plan == MONTHLY ? null : MONTHLY)}
          />
        </div>

        <div style={plan == ANNUAL ? { ...style.card, ...style.cardOn } : style.card} className='mt-12'>
          <div style={style.cardContent}>
            <div style={style.cardTitle}>{trans(73)}</div>
            <div style={style.paidTag}>{trans(74)}</div>
            <div style={style.price} className='mt-8'>${pricing.annual}<span style={typography.body['15_regular']}> / {t('year_n').toLowerCase()}</span> </div>
            <div style={style.note} className='mt-16'>{trans(76)}</div>
          </div>
          <CheckCircle
            checked={plan == ANNUAL}
            onPress={() => setPlan(plan == ANNUAL ? null : ANNUAL)}
          />
        </div>
        <Note className="mt-64">
          {trans(95)}
        </Note>

      </div>
      <div className="fixed-button-wrapper">
        <Button
          text={t('confirm')}
          onClick={handleNext}
          disabled={disabled}
          className={(!disabled ? "primary-on-button" : "primary-off-button") + " primary-button-text"}
        />
      </div>

    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll',
    paddingBottom: 80
  },
  card: {
    backgroundColor: colors.surfaceColor600,
    border: '1px solid transparent',
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
    padding: 20
  },
  cardOn: {
    backgroundColor: colors.surfaceColor500,
    border: `1px solid ${colors.primaryColor300}`
  },
  cardContent: {
    color: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  price: {
    ...typography.title.l_28_medium
  },
  note: {
    ...typography.body['15_regular'],
    color: colors.primaryColor100
  },
  subtitle: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    width: '100%',
    marginBottom: 10
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  subtag: {
    ...typography.caption_12_regular,
    color: '#fff',
    backgroundColor: '#40788F',
    borderRadius: 20,
    padding: '3px 8px',
    marginTop: 16,
    alignSelf: 'flex-start'
  },
  paidTag: {
    ...typography.caption_12_regular,
    color: colors.white,
    backgroundColor: colors.primaryColor600,
    padding: '2px 8px',
    borderRadius: 20,
    marginTop: 16
  },
  freeTag: {
    ...typography.label_11_regular,
    color: colors.white,
    backgroundColor: colors.mono600,
    padding: '2px 4px',
    borderRadius: 5,
    marginTop: 16
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 18px'

  },
  contentTitle: {
    ...typography.body["15_medium"],
    color: '#fff',
    textAlign: 'center'
  },
  contentDescription: {
    ...typography.body["15_regular"],
    color: colors.mono300,
    marginTop: 6,
    textAlign: 'center'
  },
  top: {
    backgroundColor: '#111D22',
    border: '1px solid transparent',
    borderRadius: 13,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',

  },
  cardContent1: {
    color: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  tag: {
    ...typography.footnote_13,
    color: colors.white,
    backgroundColor: '#28A6FF',
    padding: '2px 8px',
    borderRadius: 20
  }
}